<template>
  <div>
    <hero-section />
    <problem-section />
    <how-it-works-section />
    <formula-section />
    <regulation-section />
    <kpi-section />
    <contours-section />
    <features-section />
    <telegram-section />
    <interface-section />
    <audience-section />
    <demo-offer-section />
    <faq-section />
    <cta-section />
  </div>
</template>

<script>
import HeroSection from '../components/home/HeroSection.vue'
import ProblemSection from '../components/home/ProblemSection.vue'
import HowItWorksSection from '../components/home/HowItWorksSection.vue'
import FormulaSection from '../components/home/FormulaSection.vue'
import RegulationSection from '../components/home/RegulationSection.vue'
import KpiSection from '../components/home/KpiSection.vue'
import ContoursSection from '../components/home/ContoursSection.vue'
import FeaturesSection from '../components/home/FeaturesSection.vue'
import TelegramSection from '../components/home/TelegramSection.vue'
import InterfaceSection from '../components/home/InterfaceSection.vue'
import AudienceSection from '../components/home/AudienceSection.vue'
import DemoOfferSection from '../components/home/DemoOfferSection.vue'
import FaqSection from '../components/home/FaqSection.vue'
import CtaSection from '../components/home/CtaSection.vue'

export default {
  name: 'HomePage',
  components: {
    HeroSection,
    ProblemSection,
    HowItWorksSection,
    FormulaSection,
    RegulationSection,
    KpiSection,
    ContoursSection,
    FeaturesSection,
    TelegramSection,
    InterfaceSection,
    AudienceSection,
    DemoOfferSection,
    FaqSection,
    CtaSection,
  },
}
</script>
